export var DataZoomActiveTag;

!function(DataZoomActiveTag) {
    DataZoomActiveTag.startHandler = "startHandler", DataZoomActiveTag.endHandler = "endHandler", 
    DataZoomActiveTag.middleHandler = "middleHandler", DataZoomActiveTag.background = "background";
}(DataZoomActiveTag || (DataZoomActiveTag = {}));

export var IDataZoomInteractiveEvent;

!function(IDataZoomInteractiveEvent) {
    IDataZoomInteractiveEvent.stateUpdate = "stateUpdate", IDataZoomInteractiveEvent.maskUpdate = "maskUpdate", 
    IDataZoomInteractiveEvent.dataZoomUpdate = "dataZoomUpdate";
}(IDataZoomInteractiveEvent || (IDataZoomInteractiveEvent = {}));

export var IDataZoomEvent;

!function(IDataZoomEvent) {
    IDataZoomEvent.dataZoomChange = "dataZoomChange";
}(IDataZoomEvent || (IDataZoomEvent = {}));
//# sourceMappingURL=type.js.map